export default "__VITE_ASSET__71a22c81__"